/* eslint-disable no-unused-vars */

import * as ScrollMagic from 'scrollmagic';
import { TweenMax, Linear } from 'gsap/all';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { Component } from '../core/component';

// uncomment next line in addition .addIndicators() to show triggers for debug
/* eslint-disable-next-line */
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export class Labels extends Component {
    constructor() {
        super();
        this.selector = '.sectionLabel';
    }

    init() {
        const body = document.getElementsByTagName('body')[0];
        const labels = document.querySelectorAll('.sectionLabel');
        const data = [];

        function getDetails(elem) { // crossbrowser version
            const box = elem.getBoundingClientRect();
            const docEl = document.documentElement;

            const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
            const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

            const clientTop = docEl.clientTop || body.clientTop || 0;
            const clientLeft = docEl.clientLeft || body.clientLeft || 0;

            const top = box.top + scrollTop - clientTop;
            const left = box.left + scrollLeft - clientLeft;

            return {
                top: Math.round(top),
                left: Math.round(left),
                width: Math.round(box.width),
                height: Math.round(box.height),
            };
        }

        function init() {
            labels.forEach((label) => {
                data.push(getDetails(label));
            });

            // console.log(data);

            labels.forEach((label, index) => {
                const nextIndex = index + 1;
                const line = label.querySelector('[data-label-line]');

                function getDistance() {
                    return data[nextIndex] !== undefined
                        ? data[nextIndex].top - data[index].top - data[index].height - 20 : 0;
                }

                const height = getDistance();
                const duration = getDistance();

                // hide last line animation if not a next label is unavailable
                line.setAttribute('aria-hidden', data[nextIndex] !== undefined ? 'false' : 'true');

                // init controler
                const controller = new ScrollMagic.Controller({
                    globalSceneOptions: {
                        duration,
                    },
                });

                // build scene
                // uncomment .addIndicators to show triggers for debug
                const scene = new ScrollMagic.Scene({ triggerElement: line })
                    .setTween(line, { width: height, ease: Linear.easeNone })
                    .setClassToggle(line, 'active')
                    // .addIndicators()
                    .triggerHook(0.7)
                    .addTo(controller);

                // on scroll update duration height
                window.addEventListener('scroll', () => {
                    const durationScroll = getDistance();
                    scene.duration(durationScroll);
                });
            });
        }

        window.addEventListener('DOMContentLoaded', (event) => {
            init();
        });
    }
}
